module.exports = __webpack_public_path__ + "static/media/supermarket.577084d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/supermarket.png
// module id = 339
// module chunks = 0